import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 微前端
import MicroRouter from './micro-router'
export default new Router({
    mode: 'history', // 后端支持可开
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        ...MicroRouter
    ]
})
